import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e8fb22e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "td-colon" }, ":", -1))
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "image-attribute-image-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "td-colon" }, ":", -1))
const _hoisted_8 = { key: 3 }

import {
  ScrollContent,
  ToggleContent,
  ButtonContainer,
  ButtonItem,
  InlineLink,
} from "@/components/modules";
import {
  withDefaults,
  onMounted,
  Ref,
  ref,
} from "vue";
import { IAttributeImageConvert } from "@/attribute/convert/IAttributeImageConvert";
import { AttributeView } from "@/attribute/convert/AttributeView";

interface Props {
  attributeConvert: IAttributeImageConvert;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'image-attribute',
  props: {
    attributeConvert: {}
  },
  emits: ["exportCsv", "exportJson", "moveMapToGeometry"],
  setup(__props: any, { emit }) {

const props = __props;




/**
 * 画像URL
 */
const imageUrl: Ref<string> = ref(null);

/**
 * 表示データ
 */
const viewFormatData: Ref<AttributeView> = ref(null);

/**
 * 詳細開閉状態
 */
const isOpenToggle = ref(false);

/**
 * 詳細開閉状態更新
 */
const updateIsOpenToggle = (value: boolean) => {
  isOpenToggle.value = value;
};

/**
 * CSV出力
 */
const exportCsv = () => {
  emit("exportCsv", props.attributeConvert);
};

/**
 * JSON出力
 */
const exportJson = () => {
  emit("exportJson", props.attributeConvert);
};

/**
 * 地図を地物の位置へ移動
 */
const moveMapToGeometry = () => {
  const geometry = props.attributeConvert
    .getExportValue()
    .feature.getGeometry();
  emit("moveMapToGeometry", geometry);
};

/**
 * 初期処理
 */
onMounted(() => {
  viewFormatData.value = props.attributeConvert?.getViewFormatData();
  const url = props.attributeConvert.getImageUrl();
  fetch(url, {
    headers: {
      custom: "viewer",
    },
  })
    .then((res) => res.blob())
    .then((blob) => {
      imageUrl.value = URL.createObjectURL(blob);
    })
    .catch(() => {
      imageUrl.value = url;
    });
});

return (_ctx: any,_cache: any) => {
  const _component_dev = _resolveComponent("dev")!

  return (_openBlock(), _createBlock(_unref(ScrollContent), {
    height: 
      viewFormatData.value?.height && !isOpenToggle.value
        ? viewFormatData.value.height + 'px'
        : viewFormatData.value?.maxheight && isOpenToggle.value
        ? viewFormatData.value.maxheight + 'px'
        : '500px'
    
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(InlineLink), { onClick: moveMapToGeometry }, {
        default: _withCtx(() => [
          _createTextVNode("地物に移動")
        ]),
        _: 1
      }),
      (_openBlock(), _createElementBlock("table", {
        key: viewFormatData.value?.attributeValues[0]?.key
      }, [
        (isOpenToggle.value || viewFormatData.value?.attributeValues[0]?.isSimple)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
              _createElementVNode("td", null, _toDisplayString(viewFormatData.value.attributeValues[0].key), 1),
              _hoisted_2,
              _createElementVNode("td", null, [
                _createElementVNode("a", {
                  href: imageUrl.value,
                  target: "_blank"
                }, _toDisplayString(viewFormatData.value.attributeValues[0].value !== null &&
              viewFormatData.value.attributeValues[0].value !== undefined &&
              String(viewFormatData.value.attributeValues[0].value).replaceAll(
                " ",
                ""
              ) !== ""
                ? String(viewFormatData.value.attributeValues[0].value)
                : "-"), 9, _hoisted_3)
              ])
            ]))
          : _createCommentVNode("", true)
      ])),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: imageUrl.value,
          crossorigin: "anonymous",
          onError: _cache[0] || (_cache[0] = 
          () => {
            imageUrl.value = null;
          }
        )
        }, null, 40, _hoisted_5)
      ]),
      (viewFormatData.value?.attributeValues?.length > 1)
        ? (_openBlock(), _createBlock(_component_dev, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewFormatData.value?.attributeValues?.length - 1, (index) => {
                return (_openBlock(), _createElementBlock("table", {
                  key: viewFormatData.value.attributeValues[index].key
                }, [
                  (isOpenToggle.value || viewFormatData.value.attributeValues[index].isSimple)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                        _createElementVNode("td", null, _toDisplayString(viewFormatData.value.attributeValues[index].key), 1),
                        _hoisted_7,
                        _createElementVNode("td", null, _toDisplayString(viewFormatData.value.attributeValues[index].value !== null &&
              viewFormatData.value.attributeValues[index].value !== undefined &&
              String(viewFormatData.value.attributeValues[index].value).replaceAll(
                " ",
                ""
              ) !== ""
                ? String(viewFormatData.value.attributeValues[index].value)
                : "-"), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        (isOpenToggle.value ||
          (viewFormatData.value?.attributeValues &&
            !viewFormatData.value.attributeValues.some((ele) => {
              return !ele.isSimple;
            }))) &&
        (!viewFormatData.value?.csvOutputUnPossibility ||
          !viewFormatData.value?.jsonOutputUnPossibility)
      )
        ? (_openBlock(), _createBlock(_unref(ButtonContainer), {
            key: 1,
            align: "left"
          }, {
            default: _withCtx(() => [
              (!viewFormatData.value.csvOutputUnPossibility)
                ? (_openBlock(), _createBlock(_unref(ButtonItem), {
                    key: 0,
                    onClick: exportCsv
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("CSV出力")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!viewFormatData.value.jsonOutputUnPossibility)
                ? (_openBlock(), _createBlock(_unref(ButtonItem), {
                    key: 1,
                    onClick: exportJson
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("GeoJSON出力")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        viewFormatData.value?.attributeValues?.some((ele) => {
          return !ele.isSimple;
        })
      )
        ? (_openBlock(), _createBlock(_unref(ToggleContent), {
            key: 2,
            class: "detail-items",
            text: { open: '詳細表示', close: '詳細非表示' },
            onToggle: updateIsOpenToggle
          }))
        : _createCommentVNode("", true),
      (!viewFormatData.value || viewFormatData.value.attributeValues?.length < 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 表示対象の属性がありません。 "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["height"]))
}
}

})